import { START_GET_ROLES } from '../types';
    
export const getRoles = () => ({
    type: START_GET_ROLES
})